import classnames from 'classnames';
import { GatsbyImage } from "gatsby-plugin-image";
import React from 'react';

import FeaturedLink from '../UI/FeaturedLink/FeaturedLink';
import Link from '../UI/Link/Link';
import * as styles from './FeatureBlock.module.scss';

const FeatureBlock = ({
  title,
  description,
  image,
  path,
  isSecondary = false,
}) => {
  const className = classnames({
    [ styles.isPrimary ]: !isSecondary,
    [ styles.isSecondary ]: isSecondary,
  });

  return (
    <article className={className}>
      <Link className={styles.inner} to={path}>
        <GatsbyImage
          image={image?.localFile?.childImageSharp?.gatsbyImageData}
          className={styles.image} />
        <div className={styles.body}>
          <FeaturedLink label={title} desc={description} isSecondary={isSecondary} />
        </div>
      </Link>
    </article>
  );
};

export default FeatureBlock;
